module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-mobile@2x-8be7eb4bde3e2eb9ad81305426d58250.webp";